import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { CartProvider } from "@/context/CartContext";
import SmoothScroll from "@/components/SmoothScroll";
import Home from "@/pages/Home";
import BookingSuccess from "@/pages/BookingSuccess";

function App() {
  return (
    <div className="App min-h-screen bg-cream">
      <BrowserRouter>
        <CartProvider>
          <SmoothScroll>
            <Toaster position="top-center" richColors />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/booking-success" element={<BookingSuccess />} />
            </Routes>
          </SmoothScroll>
        </CartProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
